export const TABS = [
  ["all", "All"],
  ["progress", "In progress"],
  ["completed", "Completed"],
];

const isDone = (item) => (item.progress?.percent ?? 0) >= 100;

// The API returns the most recently watched first, but the reducer keys by
// course id, so restore that order from last_viewed_at.
export function sortJoined(data) {
  return Object.values(data ?? {})
    .filter((item) => item.course)
    .sort((a, b) =>
      String(b.progress?.last_viewed_at ?? b.created_at ?? "").localeCompare(String(a.progress?.last_viewed_at ?? a.created_at ?? ""))
    );
}

export function filterJoined(items, tab, query) {
  const q = query.trim().toLowerCase();
  return items
    .filter((i) => (tab === "all" ? true : tab === "completed" ? isDone(i) : !isDone(i)))
    .filter((i) => !q || String(i.course.name ?? "").toLowerCase().includes(q));
}

// [title, text] for an empty list, depending on why it is empty.
export function emptyMessage(items, tab, query) {
  if (!items.length) return ["You haven't joined a class yet", "Pick your first class. Free classes open straight at lesson 1."];
  if (query.trim()) return ["No classes match your search", "Try another word, or clear the search."];
  if (tab === "completed") return ["Nothing completed yet", "Finish every lesson in a class and it shows up here."];
  return ["All caught up", "Find a new class to keep learning."];
}
